export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const API_KEY = '2fe95176-316d-41ee-b544-8c176010c15f';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const MODAL_CLOSE_SEC = 2.5;
